import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../components/forms/input'
import MyRichText from '../../components/forms/richText'
import MyImageUpload from '../../components/forms/imageUpload'
import MyTextArea from '../../components/forms/textArea'

const AddCoach = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '教练名称不能为空'})
      return false
    }
    if (!formValue.avatar_url) {
      setErrorMsg({avatarEmpty: '教练头像不能为空'})
      return false
    }
    if (!formValue.photo_url) {
      setErrorMsg({photoEmpty: '教练照片不能为空'})
      return false
    }
    if (!formValue.abstract) {
      setErrorMsg({abstractEmpty: '个人摘要不能为空'})
      return false
    }
    if (!formValue.introduction) {
      setErrorMsg({introductionEmpty: '详细介绍不能为空'})
      return false
    }

    axios.post('/admin/content/coach/add', {
      name: formValue.name,
      abstract: formValue.abstract,
      introduction: formValue.introduction,
      avatar_url: formValue.avatar_url,
      photo_url: formValue.photo_url,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('创建成功！')
          props.getCoachData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加教练"
      width='800px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
      ]}>

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='教练名称'
        placeholder='请输入教练名称'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyImageUpload 
        id="avatar_url"
        required
        label='教练头像'
        value={formValue.avatar_url}
        setValue={setFormValue}
        errorMsg={errorMsg.avatarEmpty}
      />

      <MyImageUpload 
        id="photo_url"
        required
        label='教练照片'
        value={formValue.photo_url}
        setValue={setFormValue}
        errorMsg={errorMsg.photoEmpty}
      />

      <MyTextArea
        id="abstract"
        required
        label='个人摘要'
        minRows={2}
        placeholder='请输入'
        value={formValue.abstract}
        onChange={setFormValue}
        errorMsg={errorMsg.abstractEmpty}
      />

      <MyRichText
        id='introduction'
        required
        label='详细介绍'
        value={formValue.introduction}
        setValue={setFormValue}
        errorMsg={errorMsg.introductionEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default AddCoach
